import React, { Component } from 'react';
import Footer from './Footer';

export const footer = <Footer />;

export const contentFooter = (
  <>
    본 사이트는 RECAPTCHA와 구글{' '}
    <a href="https://policies.google.com/privacy?hl=ko" target="_blank" rel="noopener noreferrer">
      개인정보 처리방침
    </a>{' '}
    및{' '}
    <a href="https://policies.google.com/terms?hl=ko" target="_blank" rel="noopener noreferrer">
      사용약관
    </a>
    에 의해 보호받고 있습니다.
  </>
);
